import { useTranslation } from 'react-i18next';
import Typography from '../../sharedComponents/Typography/Typography';
import PayPalLoginButton from '../PayPalLoginButton/PayPalLoginButton';
import { AddPayoutAccountPayPalFormProps } from './AddPayoutAccountPayPalForm.types';
import styles from './add-payout-account-paypal-form.module.scss';

const AddPayoutAccountPayPalForm: React.FC<AddPayoutAccountPayPalFormProps> = ({
  errorMsg = '',
  onLogIn,
  processingRequest,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography variant="body-2" align="center">
        {t('sunshine.content.paypal_login_explainer')}
      </Typography>

      <div className={styles.loginButton}>
        <PayPalLoginButton disabled={processingRequest} onClick={onLogIn} />
      </div>

      {processingRequest && (
        <Typography variant="body-3" align="center">
          {t('sunshine.content.waiting_for_paypal')}
        </Typography>
      )}

      <Typography variant="error" align="center">
        {errorMsg}
      </Typography>
    </div>
  );
};

export default AddPayoutAccountPayPalForm;
